<template>
  <section>
    <!-- Image -->
    <div class="row">
      <div class="col-12">
        <img src="/static/img/scb01.jpg" class="img-fluid">
      </div>
      <div class="col-12">
        <img src="/static/img/scb02.jpg" class="img-fluid">
      </div>
    </div>

    <!-- Section Benefit -->
    <section class="section-padding section-solution">
      <h2 class="text-center">{{ $t('message.scb.benefits_title') }}</h2>
      <div class="row">
        <div class="col-sm-3 col-md-3 text-center">
          <img src="/static/img/ic_benefit01.png" width="60">
          <h3>{{ $t('message.scb.benefits_detail01') }}</h3>
        </div>
        <div class="col-sm-3 col-md-3 text-center">
          <img src="/static/img/ic_benefit02.png" width="60">
          <h3>{{ $t('message.scb.benefits_detail02') }}</h3>
          <p>{{ $t('message.scb.benefits_detail02_01') }}</p>
          <p>{{ $t('message.scb.benefits_detail02_02') }}</p>
          <p>{{ $t('message.scb.benefits_detail02_03') }}</p>
        </div>
        <div class="col-sm-3 col-md-3 text-center">
          <img src="/static/img/ic_benefit03.png" width="60">
          <h3>{{ $t('message.scb.benefits_detail03') }}</h3>
        </div>
        <div class="col-sm-3 col-md-3 text-center">
          <img src="/static/img/ic_benefit04.png" width="60">
          <h3>{{ $t('message.scb.benefits_detail04') }}</h3>
        </div>
      </div>
    </section>

    <!-- Section Form -->
    <section class="section-padding-gray">
      <h2 class="text-center">{{ $t('message.scb.form_title') }}</h2>
      <div class="row">
        <div class="col-lg-6 offset-lg-3">
          <div class="card">
            <div class="card-body">
              <div class="form">
                <div class="form-group">
                  <label for="credit_card">{{ $t('message.scb.credit_card_title') }}*</label>
                  <cleave class="form-control input-jumbo"
                          placeholder="•••• •••• •••• ••••"
                          ref="creditCard"
                          v-model="creditCard"
                          :options="{ creditCard: true }"></cleave>
                  <p class="text-error" v-if="creditCardStatus == 1">
                  <ul style="margin-left: 1.5rem;">
                    <li>กรุณากรอกหมายเลขบัตร</li>
                  </ul>
                  </p>
                  <p class="text-error" v-else-if="creditCardStatus == 2">
                  <ul style="margin-left: 1.5rem;">
                    <li>หมายเลขบัตรไม่ถูกต้อง</li>
                  </ul>
                  </p>
                </div>
                <div class="form-group">
                  <label for="email">{{ $t('message.scb.email_title') }}*</label>
                  <input type="email"
                         class="form-control input-jumbo"
                         id="email"
                         ref="email"
                         v-model="formData.email"
                         required>
                  <p class="text-error" v-if="emailStatus == 1">
                  <ul style="margin-left: 1.5rem;">
                    <li>กรุณากรอก Email</li>
                  </ul>
                  </p>
                  <p class="text-error" v-else-if="emailStatus == 2">
                  <ul style="margin-left: 1.5rem;">
                    <li>Email ไม่ถูกต้อง</li>
                  </ul>
                  </p>
                </div>
                <div class="form-group">
                  <label for="tel">{{ $t('message.scb.tel_title') }}*</label>
                  <input type="tel"
                         class="form-control input-jumbo"
                         id="tel"
                         ref="tel"
                         v-model="formData.tel"
                         required>
                  <p class="text-error" v-if="telStatus == 1">
                  <ul style="margin-left: 1.5rem;">
                    <li>กรุณากรอกหมายเลขโทรศัพท์</li>
                  </ul>
                  </p>
                </div>
              </div>
              <button class="button button-large button-block -cyan"
                      @click="submit"> {{ $t(isVerifyingButtonMessage) }}
              </button>
              <div class="mt-4">
                <p>{{ $t('message.scb.campaign_remark_title') }}</p>
                <ul style="margin-left: 1.5rem;">
                  <li>{{ $t('message.scb.campaign_remark_detail01') }}</li>
                  <li>{{ $t('message.scb.campaign_remark_detail02') }}</li>
                  <li>{{ $t('message.scb.campaign_remark_detail03') }}</li>
                  <li>{{ $t('message.scb.campaign_remark_detail04') }}</li>
                  <li>{{ $t('message.scb.campaign_remark_detail05') }}</li>
                  <li>{{ $t('message.scb.campaign_remark_detail06') }}</li>
                  <li>{{ $t('message.scb.campaign_remark_detail07') }}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

  </section>
</template>

<script>
  import { mapGetters } from 'vuex'
  import Cleave from 'vue-cleave'

  export default {
    components: {
      Cleave
    },
    data () {
      return {
        formData: {
          email: null,
          tel: null,
          campaign_name: 'scb_sansiri'
        },
        creditCard: null,
        creditCardStatus: 0,
        emailStatus: 0,
        telStatus: 0
      }
    },
    computed: {
      ...mapGetters({
        isVerifying: 'scb/getIsVerifying',
        isVerifyingButtonMessage: 'scb/isVerifyingButtonMessage'
      })
    },
    watch: {
      isVerifying () {
        if (!this.isVerifying) {
          this.formData = {
            credit_card: '',
            email: '',
            tel: '',
            campaign_name: 'scb_sansiri'
          }
          this.$swal({
            type: 'success',
            title: this.$i18n.t('message.scb.code_detail01'),
            text: this.$i18n.t('message.scb.code_detail02')
          })
        }
      }
    },
    methods: {
      validation () {
        let result = true
        let hasFocus = false
        this.creditCardStatus = 0
        this.emailStatus = 0
        this.telStatus = 0
        const emailFormat = new RegExp('^([a-z0-9\\+_\\-]+)(\\.[a-z0-9\\+_\\-]+)*@([a-z0-9\\-]+\\.)+[a-z]{2,6}$')
        const creditCardFormat1 = new RegExp('^(.*)47737606(.*)$')
        const creditCardFormat2 = new RegExp('^[0-9]{16}$')

        const creditCardNumber = this.creditCard.replace(/\s+/g, '')

        if (creditCardNumber === '') {
          if (!hasFocus) {
            this.$refs.creditCard.$el.focus()
            hasFocus = true
          }
          result = false
          this.creditCardStatus = 1
        } else if (creditCardNumber && (!creditCardFormat1.test(creditCardNumber) || !creditCardFormat2.test(creditCardNumber))) {
          this.creditCard = ''
          if (!hasFocus) {
            this.$refs.creditCard.$el.focus()
            hasFocus = true
          }
          result = false
          this.creditCardStatus = 2
        }
        if (this.formData.email === '') {
          if (!hasFocus) {
            this.$refs.email.focus()
            hasFocus = true
          }
          result = false
          this.emailStatus = 1
        } else if (this.formData.email && !emailFormat.test(this.formData.email)) {
          this.formData.email = ''
          if (!hasFocus) {
            this.$refs.email.focus()
            hasFocus = true
          }
          result = false
          this.emailStatus = 2
        }
        if (this.formData.tel === '') {
          if (!hasFocus) {
            this.$refs.tel.focus()
            hasFocus = true
          }
          result = false
          this.telStatus = 1
        }
        return result
      },
      submit () {
        if (this.validation()) {
          this.$store.dispatch('scb/SUBMIT', this.formData)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/others/SCB.vue